import { takeEvery, takeLatest, fork, put, all, call, select } from "redux-saga/effects";
import {
    getBookingsError,
    getBookingsSuccessful,
    addBookingError,
    addBookingSuccessful,
    showAddBookingModalSuccess,
    removeBookingError,
    removeBookingSuccess,
    getBookings,
    editBookingError,
    editBookingSuccess
} from "./actions";
import BookingService from "./service";
import { BookingActionTypes } from "./actionTypes";

// Selector to get the booking query state from the Redux store.
export const getBookingQuery = state => state.Booking.query;

export function* get({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getBookingQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload };
        const response = yield call(BookingService.getBookings, finalPayload);
        yield put(getBookingsSuccessful(response));
        yield put({ type: BookingActionTypes.SET_BOOKING_QUERY, payload: finalPayload });
    } catch (error) {
        yield put(getBookingsError(error));
    }
}

export function* addBooking({ payload: booking }) {
    try {
        const response = yield call(BookingService.addBooking, booking);
        yield put(addBookingSuccessful(response));
        yield put(getBookings()); // This will now use the correct state from the store.

    } catch (error) {
        yield put(addBookingError(error));
    }
}

export function* showAddBooking({ payload: showModal }) {
    yield put(showAddBookingModalSuccess(showModal));
}

export function* removeBooking({ payload: bookingId }) {
    try {
        const response = yield call(BookingService.removeBooking, bookingId);
        yield put(removeBookingSuccess(response));
        yield put(getBookings()); // This will now use the correct state from the store.
    } catch (error) {
        yield put(removeBookingError(error));
    }
}

export function* edit({ payload: booking }) {
    try {
        const response = yield call(BookingService.editBooking, booking);
        yield put(editBookingSuccess(response));
        yield put(getBookings()); // This will now use the correct state from the store.
    } catch (error) {
        yield put(editBookingError(error));
    }
}

export function* watchGetBooking() {
    yield takeLatest(BookingActionTypes.BOOKING_LIST_GET, get);
}

export function* watchAddBooking() {
    yield takeEvery(BookingActionTypes.BOOKING_ADD, addBooking);
}

export function* watchShowAddBookingModal() {
    yield takeEvery(BookingActionTypes.BOOKING_ADD_MODAL, showAddBooking);
}

export function* watchRemoveBooking() {
    yield takeEvery(BookingActionTypes.BOOKING_REMOVE, removeBooking);
}

export function* watchEditBooking() {
    yield takeEvery(BookingActionTypes.BOOKING_EDIT, edit);
}

function* bookingsSaga() {
    yield all([
        fork(watchGetBooking),
        fork(watchAddBooking),
        fork(watchShowAddBookingModal),
        fork(watchRemoveBooking),
        fork(watchEditBooking)
    ]);
}

export default bookingsSaga;
